module.exports = __webpack_public_path__ + "img/mrBts_test_002_BS.911187d9.jpg";